import { AUTOMATION_STAGE_STATUSES } from '../genericAutomationStageStatuses'

export const GOOGLE_AUTOMATION_STAGE_STATUSES = {
  ...AUTOMATION_STAGE_STATUSES,
}
